/* ==========================================================================
   ATTITUDE — i18n (IT / EN / ES)
   Add new strings by adding a data-i18n="key" attribute to any element,
   then adding that key under all three languages below.
   Use data-i18n-placeholder="key" for <input placeholder="">.
   ========================================================================== */

const ATTITUDE_I18N = {
  it: {
    nav_new: "Nuovi arrivi",
    nav_collection: "Collezione",
    nav_manifesto: "Manifesto",
    nav_contact: "Contatti",
    cart_label: "Carrello",

    hero_title_1: "Cosa vuoi",
    hero_title_2: "davvero?",
    hero_sub: "Vestiamo chi si sta costruendo la propria libertà, un giorno alla volta.",
    hero_cta: "Scopri la collezione",

    marquee_1: "Costruito per chi crea",
    marquee_2: "Edizioni limitate",
    marquee_3: "Spedizione in tutta Europa",

    manifesto_label: "01 — Il manifesto",
    manifesto_text: " — Ogni impero è partito da un garage, <em>da una stanza,</em> da un'idea scritta su un tovagliolo. <span class=\"accent\">Attitude</span> è il capo che indossi mentre lo costruisci — <em></em>",

    products_title: "La<br>collezione",
    products_sub: "Pezzi essenziali, pensati per chi passa più tempo a lavorare che a posare.",
    tag_new: "Nuovo",

    product_bottlegreen: "Cappello Bottle Green",
    product_classicred: "Cappello Classic Red",
    product_frenchnavy: "Cappello French Navy",
    product_militarygreen: "Cappello Military Green",

    collections_title: "Le nostre collezioni",
    collections_sub: "Ogni collezione è un capitolo diverso della stessa storia.",
    collections_empty: "Le collezioni arrivano a breve.",
    collection_eyebrow: "Collezione", collection_empty: "Nessun pezzo disponibile al momento in questa collezione.",

    process_title: "Come nasce<br>un pezzo",
    process_sub: "Ogni capo passa attraverso quattro fasi prima di raggiungerti. Nessuna scorciatoia.",
    step1_title: "Idea",
    step1_desc: "Non è una domanda. È una scelta: rinunciare alla sicurezza per costruirsi la propria libertà.",
    step2_title: "Materiali",
    step2_desc: "Tessuti selezionati per durare — pensati per l'uso quotidiano, non per lo scaffale.",
    step3_title: "Produzione",
    step3_desc: "Lotti limitati. Quando un pezzo finisce, finisce — nessun riassortimento infinito.",
    step4_title: "Rilascio",
    step4_desc: "Arriva alla community prima che ovunque altro. Prima gli iscritti, poi i follower.",

    identity_label: "02 — Chi siamo",
    identity_title: "Show your<br>attitude",
    identity_text: "Attitude è nata per ispirare le persone a perseguire i propri obiettivi e a realizzarli. Una community in cui crescere, condividere e trovare sostegno lungo il percorso — qualunque punto tu abbia raggiunto.",
    identity_cta: "Scopri di più",

    newsletter_label: "03 — Community",
    newsletter_title: "Entra prima degli altri.",
    newsletter_placeholder: "La tua email",
    newsletter_btn: "Iscriviti →",

    footer_tag: "Non vestiamo chi è arrivato. Vestiamo chi sta costruendo.",
    footer_shop: "Negozio",
    footer_shop_all: "Tutti i prodotti",
    footer_shop_best: "Best seller",
    footer_support: "Assistenza",
    footer_shipping: "Spedizioni",
    footer_returns: "Resi",
    footer_contact: "Contattaci",
    footer_community: "Community",
    footer_go: "Vai",
    footer_terms: "Termini",

    cart_title: "Carrello",
    cart_empty: "Il tuo carrello è vuoto.",
    cart_continue: "Continua lo shopping",

    breadcrumb_home: "Home",

    pdp_category: "Cappelli — Edizione limitata",
    pdp_title: "Cappello<br>Bottle Green",
    pdp_color_prefix: "Colore —",
    pdp_size_label: "Taglia",
    pdp_size_guide: "Guida taglie",
    pdp_size_unique: "Unica",
    pdp_qty_label: "Quantità",
    pdp_add_to_cart: "Aggiungi al carrello",
    pdp_added: "Aggiunto ✓",
    pdp_buy_now: "Acquista ora",
    pdp_micro1: "Spedizione in 2–4 giorni lavorativi in tutta Italia",
    pdp_micro2: "Resi gratuiti entro 14 giorni",
    pdp_micro3: "Pezzo in edizione limitata — quando finisce, finisce",

    accordion_details: "Dettagli",
    accordion_details_text: "100% cotone twill strutturato, visiera pre-curvata, chiusura posteriore regolabile. Ricamo 3D con logo Attitude sul frontale. Fit unisex, taglia unica.",
    accordion_shipping: "Spedizioni e resi",
    accordion_shipping_text: "Spedizione standard 2–4 giorni lavorativi in Italia, 5–8 giorni nel resto d'Europa. Resi gratuiti entro 14 giorni dalla consegna, articolo non indossato con etichette originali.",
    accordion_care: "Materiali & cura",
    accordion_care_text: "Lavare a mano in acqua fredda o pulire con panno umido. Non candeggiare. Asciugare all'aria, lontano da fonti di calore dirette.",

    related_title: "Completa<br>il look",
    related_sub: "Altri pezzi dalla stessa collezione."
  },

  en: {
    nav_new: "New arrivals",
    nav_collection: "Collection",
    nav_manifesto: "Manifesto",
    nav_contact: "Contact",
    cart_label: "Cart",

    hero_title_1: "What do you",
    hero_title_2: "really want?",
    hero_sub: "We don't dress those who've already made it. We dress those building it, one day at a time.",
    hero_cta: "Explore the collection",

    marquee_1: "Built for those who create",
    marquee_2: "Limited editions",
    marquee_3: "Shipping across Europe",

    manifesto_label: "01 — The manifesto",
    manifesto_text: "Every empire started in a garage, <em>in a room,</em> as an idea scribbled on a napkin. <span class=\"accent\">Attitude</span> is what you wear while you build it — <em>not what you wear once you've made it.</em>",

    products_title: "The<br>collection",
    products_sub: "Essential pieces, made for people who spend more time working than posing.",
    tag_new: "New",

    product_bottlegreen: "Bottle Green Cap",
    product_classicred: "Classic Red Cap",
    product_frenchnavy: "French Navy Cap",
    product_militarygreen: "Military Green Cap",

    collections_title: "Our collections",
    collections_sub: "Every collection is a different chapter of the same story.",
    collections_empty: "Collections are coming soon.",
    collection_eyebrow: "Collection", collection_empty: "No pieces available in this collection right now.",
    process_title: "How a piece<br>comes to life",
    process_sub: "Every piece goes through four stages before it reaches you. No shortcuts.",
    step1_title: "Idea",
    step1_desc: "It starts with a simple question: what would someone building something of their own actually wear?",
    step2_title: "Materials",
    step2_desc: "Fabrics chosen to last — made for everyday use, not for sitting on a shelf.",
    step3_title: "Production",
    step3_desc: "Limited batches. When a piece sells out, it's gone — no endless restocking.",
    step4_title: "Release",
    step4_desc: "It reaches the community before anywhere else. Subscribers first, everyone else after.",

    identity_label: "02 — Who we are",
    identity_title: "Show your<br>attitude",
    identity_text: "Attitude was born to inspire people to chase their dreams and make them real. A community to grow, share, and find support along the way — wherever you are on the journey.",
    identity_cta: "Learn more",

    newsletter_label: "03 — Community",
    newsletter_title: "Get in before everyone else.",
    newsletter_placeholder: "Your email",
    newsletter_btn: "Subscribe →",

    footer_tag: "We don't dress those who've arrived. We dress those who are building.",
    footer_shop: "Shop",
    footer_shop_all: "All products",
    footer_shop_best: "Best sellers",
    footer_support: "Support",
    footer_shipping: "Shipping",
    footer_returns: "Returns",
    footer_contact: "Contact us",
    footer_community: "Community",
    footer_go: "Go",
    footer_terms: "Terms",

    cart_title: "Cart",
    cart_empty: "Your cart is empty.",
    cart_continue: "Continue shopping",

    breadcrumb_home: "Home",

    pdp_category: "Caps — Limited edition",
    pdp_title: "Bottle Green<br>Cap",
    pdp_color_prefix: "Color —",
    pdp_size_label: "Size",
    pdp_size_guide: "Size guide",
    pdp_size_unique: "One size",
    pdp_qty_label: "Quantity",
    pdp_add_to_cart: "Add to cart",
    pdp_added: "Added ✓",
    pdp_buy_now: "Buy now",
    pdp_micro1: "Delivery in 2–4 business days across Italy",
    pdp_micro2: "Free returns within 14 days",
    pdp_micro3: "Limited edition piece — once it's gone, it's gone",

    accordion_details: "Details",
    accordion_details_text: "100% structured cotton twill, pre-curved brim, adjustable back closure. 3D embroidered Attitude logo on the front. Unisex fit, one size.",
    accordion_shipping: "Shipping & returns",
    accordion_shipping_text: "Standard shipping 2–4 business days in Italy, 5–8 days across the rest of Europe. Free returns within 14 days of delivery, item unworn with original tags.",
    accordion_care: "Materials & care",
    accordion_care_text: "Hand wash in cold water or spot clean with a damp cloth. Do not bleach. Air dry, away from direct heat.",

    related_title: "Complete<br>the look",
    related_sub: "More pieces from the same collection."
  },

  es: {
    nav_new: "Novedades",
    nav_collection: "Colección",
    nav_manifesto: "Manifiesto",
    nav_contact: "Contacto",
    cart_label: "Carrito",

    hero_title_1: "¿Qué quieres",
    hero_title_2: "de verdad?",
    hero_sub: "No vestimos a quien ya lo ha conseguido. Vestimos a quien lo está construyendo, un día a la vez.",
    hero_cta: "Descubre la colección",

    marquee_1: "Hecho para quienes crean",
    marquee_2: "Ediciones limitadas",
    marquee_3: "Envíos a toda Europa",

    manifesto_label: "01 — El manifiesto",
    manifesto_text: "Todo imperio empezó en un garaje, <em>en una habitación,</em> como una idea escrita en una servilleta. <span class=\"accent\">Attitude</span> es lo que llevas mientras lo construyes — <em></em>",

    products_title: "La<br>colección",
    products_sub: "Piezas esenciales, pensadas para quienes pasan más tiempo trabajando que posando.",
    tag_new: "Nuevo",

    product_bottlegreen: "Gorra Bottle Green",
    product_classicred: "Gorra Classic Red",
    product_frenchnavy: "Gorra French Navy",
    product_militarygreen: "Gorra Military Green",

    collections_title: "Nuestras colecciones",
    collections_sub:  "Cada colección es un capítulo distinto de la misma historia.",
    collections_empty: "Las colecciones llegan pronto.",
    collection_eyebrow: "Colección", collection_empty: "Ningún artículo disponible por ahora en esta colección.",
    process_title: "Cómo nace<br>una pieza",
    process_sub: "Cada prenda pasa por cuatro fases antes de llegar a ti. Sin atajos.",
    step1_title: "Idea",
    step1_desc: "Nace de una pregunta simple: ¿qué llevaría alguien que está construyendo algo propio?",
    step2_title: "Materiales",
    step2_desc: "Tejidos elegidos para durar — pensados para el uso diario, no para el estante.",
    step3_title: "Producción",
    step3_desc: "Lotes limitados. Cuando una pieza se agota, se acabó — sin reposiciones infinitas.",
    step4_title: "Lanzamiento",
    step4_desc: "Llega primero a la comunidad. Primero los suscriptores, después el resto.",

    identity_label: "02 — Quiénes somos",
    identity_title: "Show your<br>attitude",
    identity_text: "Attitude nació para inspirar a las personas a perseguir sus sueños y hacerlos realidad. Una comunidad para crecer, compartir y encontrar apoyo en el camino — sin importar en qué punto estés.",
    identity_cta: "Descubre más",

    newsletter_label: "03 — Comunidad",
    newsletter_title: "Entra antes que los demás.",
    newsletter_placeholder: "Tu email",
    newsletter_btn: "Suscríbete →",

    footer_tag: "No vestimos a quien ya llegó. Vestimos a quien está construyendo.",
    footer_shop: "Tienda",
    footer_shop_all: "Todos los productos",
    footer_shop_best: "Más vendidos",
    footer_support: "Ayuda",
    footer_shipping: "Envíos",
    footer_returns: "Devoluciones",
    footer_contact: "Contáctanos",
    footer_community: "Comunidad",
    footer_go: "Ir",
    footer_terms: "Términos",

    cart_title: "Carrito",
    cart_empty: "Tu carrito está vacío.",
    cart_continue: "Seguir comprando",

    breadcrumb_home: "Home",

    pdp_category: "Gorras — Edición limitada",
    pdp_title: "Gorra<br>Bottle Green",
    pdp_color_prefix: "Color —",
    pdp_size_label: "Talla",
    pdp_size_guide: "Guía de tallas",
    pdp_size_unique: "Talla única",
    pdp_qty_label: "Cantidad",
    pdp_add_to_cart: "Añadir al carrito",
    pdp_added: "Añadido ✓",
    pdp_buy_now: "Comprar ahora",
    pdp_micro1: "Envío en 2–4 días laborables en toda Italia",
    pdp_micro2: "Devoluciones gratuitas en 14 días",
    pdp_micro3: "Pieza de edición limitada — cuando se agota, se acabó",

    accordion_details: "Detalles",
    accordion_details_text: "100% algodón twill estructurado, visera pre-curvada, cierre trasero ajustable. Bordado 3D con el logo de Attitude en el frontal. Fit unisex, talla única.",
    accordion_shipping: "Envíos y devoluciones",
    accordion_shipping_text: "Envío estándar 2–4 días laborables en Italia, 5–8 días en el resto de Europa. Devoluciones gratuitas en 14 días desde la entrega, artículo sin usar y con etiquetas originales.",
    accordion_care: "Materiales y cuidado",
    accordion_care_text: "Lavar a mano con agua fría o limpiar con un paño húmedo. No usar lejía. Secar al aire, lejos de fuentes de calor directas.",

    related_title: "Completa<br>el look",
    related_sub: "Más piezas de la misma colección."
  }
};

function attitudeApplyLanguage(lang) {
  if (!ATTITUDE_I18N[lang]) lang = 'it';
  const dict = ATTITUDE_I18N[lang];
  document.documentElement.lang = lang;

  document.querySelectorAll('[data-i18n]').forEach((el) => {
    const val = dict[el.dataset.i18n];
    if (val !== undefined) el.innerHTML = val;
  });
  document.querySelectorAll('[data-i18n-placeholder]').forEach((el) => {
    const val = dict[el.dataset.i18nPlaceholder];
    if (val !== undefined) el.placeholder = val;
  });
  document.querySelectorAll('[data-lang-btn]').forEach((btn) => {
    btn.classList.toggle('is-active', btn.dataset.langBtn === lang);
  });

  try { localStorage.setItem('attitude-lang', lang); } catch (e) { /* ignore */ }
}

function attitudeInitLanguage() {
  let saved = 'it';
  try { saved = localStorage.getItem('attitude-lang') || 'it'; } catch (e) { /* ignore */ }
  attitudeApplyLanguage(saved);

  document.querySelectorAll('[data-lang-btn]').forEach((btn) => {
    btn.addEventListener('click', () => attitudeApplyLanguage(btn.dataset.langBtn));
  });
}

document.addEventListener('DOMContentLoaded', attitudeInitLanguage);
